export default ['JsonRPCService', (JsonRPCService) => {
    return {
        getPolicy: (policyNumber) => {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPolicy', [policyNumber]);
        },
        getNotesForPolicy: (accountNumber) => {
            return JsonRPCService.send('pc', 'gateway/policy', 'getNotesForPolicy', [accountNumber]);
        },
        createNoteForPolicy: (policyNumber, noteDTO) => {
            return JsonRPCService.send('pc', 'gateway/policy', 'createNoteForPolicy', [policyNumber, noteDTO]);
        },
        getDocumentsForPolicy: (policyNumber) => {
            return JsonRPCService.send('pc', 'gateway/policy', 'getDocumentsForPolicy', [policyNumber]);
        },
        getPolicyTransactionsForPolicy: (policyNumber) => {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPolicyTransactionsForPolicy', [policyNumber]);
        },
        createNewPolicyChangeTransaction: (policyChange) => {
            return JsonRPCService.send('pc', 'gateway/policy', 'createPolicyChangeTransaction', [policyChange]);
        },
        createNewPolicyRenewalTransaction: (policyNumber) => {
            return JsonRPCService.send('pc', 'gateway/policy', 'createPolicyRenewalTransaction', [policyNumber]);
        },
        createNewPolicyCancellationTransaction: (policyNumber, cancellation) => {
            return JsonRPCService.send('pc', 'gateway/policy', 'createPolicyCancellationTransaction', [policyNumber, cancellation]);
        },
        getEffectiveDateForPolicyChange: (policyNumber) => {
            return JsonRPCService.send('pc', 'gateway/policy', 'getEffectiveDateForPolicyChange', [policyNumber]);
        },
        getPolicyBillingSummaryInfo: (policyNumber) => {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPolicyBillingSummaryInfo', [policyNumber]);
        },
        getPolicyClaims: (policyNumber) => {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPolicyClaims', [policyNumber]);
        },
        addRecentlyViewedPolicy: (policyNumber) => {
            return JsonRPCService.send('pc', 'gateway/policy', 'addRecentlyViewedPolicy', [policyNumber]);
        },
        getRecentlyViewedPolicies: () => {
            return JsonRPCService.send('pc', 'gateway/policy', 'getRecentlyViewedPolicies', []);
        },
        getRecentlyIssuedPolicies: (numberOfDays) => {
            return JsonRPCService.send('pc', 'gateway/policy', 'getRecentlyIssuedPolicies', [numberOfDays]);
        },
        getPolicySummariesForCurrentUser: () => {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPolicySummariesForCurrentUser', []);
        },
        getPolicySummariesFromPolicyNumbers: (policyNumbers) => {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPolicySummariesFromPolicyNumbers', [policyNumbers]);
        },
        getPolicyPeriods: (policyNumber) => {
            return JsonRPCService.send('bc', 'gatewaycommission/commission', 'getPolicyPeriods', [policyNumber]);
        },
        getPolicyCommissionSummary: (policyNumber, termNumber, producerCodes) => {
            return JsonRPCService.send('bc', 'gatewaycommission/commission', 'getPolicyCommissionSummary', [policyNumber, termNumber, producerCodes]);
        },
        getCommissionsTransactionsByPolicyPeriod: (policyNumber, termNumber) => {
            return JsonRPCService.send('bc', 'gatewaycommission/commission', 'getCommissionsTransactionsByPolicyPeriod', [policyNumber, termNumber]);
        },
        getPolicyPeriodJobType: (policyNumber, termNumber) => {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPolicyPeriodJobType', [policyNumber, termNumber]);
        },
        getIndustryCodes: (policyNumber, sessionId) => {
            return JsonRPCService.send('pc', 'gatewayquote/wc7coverables', 'getIndustryCodes', [policyNumber, sessionId]);
        },
         //getPoliciess UCWPRODENG-763
         getPoliciess: (reportData) => {
            return JsonRPCService.send('pc', 'gateway/policy', 'getPoliciess', [reportData]);
        }
    };
}];